import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Particles } from "../@/components/magicui/particles";
import { Safari } from "../@/components/magicui/safari";
import hero from "../assets/hero-img2.png";

const Hero = () => {
  const { t } = useTranslation();

  return (
    <section
      id="home"
      className="relative min-h-screen w-full flex flex-col items-center justify-center rounded-lg bg-black"
    >
      <div className="flex flex-col items-center justify-center mt-[120px] md:mt-[180px]">
        <motion.h1
          className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-center my-5 leading-tight text-white relative max-w-6xl "
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <span className="bg-clip-text text-transparent bg-gradient-to-br from-white/90 to-gray-600 drop-shadow-lg">
            {t("hero.title")}
          </span>
        </motion.h1>

        <motion.h2
          className="text-xl md:text-2xl text-center my-5 text-gray-200 max-w-3xl mx-auto relative"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
        >
          <span className="bg-clip-text text-transparent bg-gradient-to-br from-white/80 to-gray-400 drop-shadow-md">
            {t("hero.subtitle")}
          </span>
        </motion.h2>

        <motion.button
          className="boton-elegante my-5"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.6 }}
          onClick={() =>
            document
              .getElementById("about")
              ?.scrollIntoView({ behavior: "smooth" })
          }
        >
          {t("hero.knowMore")}
        </motion.button>

        <motion.span
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.6 }}
          onClick={() =>
            document
              .getElementById("about")
              ?.scrollIntoView({ behavior: "smooth" })
          }
          className="bg-clip-text mb-5 text-2xl text-center text-transparent bg-gradient-to-br from-white/80 to-gray-400 drop-shadow-md text-bold"
        >
          <br />
          V-Card (mini-website) Starting from{" "}
          <span className="text-amber-400 text-3xl"> ₹299/6 months</span>
        </motion.span>
      </div>

      {/* Rest of your component remains the same */}
      <motion.div
        className="relative size-full max-w-[800px] mt-[30px] sm:px-2 md:px-0 z-10"
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.8 }}
      >
        <Safari
          url="spotcard.in"
          className="size-full"
          style={{
            WebkitMaskImage:
              "linear-gradient(to top, rgba(0,0,0,0.1), rgba(0,0,0,1))",
            maskImage:
              "linear-gradient(to top, rgba(0,0,0,0.1), rgba(0,0,0,1))",
          }}
          imageSrc={hero}
        />
        <div className="absolute inset-0 shadow-[0_-20px_70px_rgba(255,193,8,0.5)] pointer-events-none"></div>
      </motion.div>

      <Particles
        className="absolute inset-0 z-0"
        quantity={250}
        ease={50}
        color={"#ffaa40"}
        size={1}
        staticity={20}
        refresh
        style={{
          WebkitMaskImage:
            "linear-gradient(to top, rgba(0,0,0,0.1), rgba(0,0,0,1))",
          maskImage: "linear-gradient(to top, rgba(0,0,0,0.1), rgba(0,0,0,1))",
        }}
      />
    </section>
  );
};

export default Hero;
